export const WHITE = '#FFFFFF';
export const SOFT_LAVENDER = '#E2DAF7';